/** The Backup board's shared panel chrome: an outlined card with a title and caption. */

import { Card, Typography } from "@norican/react";
import type { ReactNode } from "react";

interface PanelCardProps {
  /** Panel heading. */
  title: string;
  /** Muted line beside the heading — a count, a scope, a caveat. */
  caption?: ReactNode;
  /** Panel content. */
  children: ReactNode;
  /**
   * Body padding. `none` for panels whose content is a full-bleed `DataGrid`,
   * which brings its own.
   */
  padding?: "none" | "sm" | "md" | "lg";
}

export function PanelCard({ title, caption, children, padding = "md" }: PanelCardProps) {
  return (
    <Card variant="outline">
      <Card.Header>
        <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
          <Typography variant="heading-4" as="h2">
            {title}
          </Typography>
          {caption && (
            <Typography variant="body-sm" tone="muted">
              {caption}
            </Typography>
          )}
        </div>
      </Card.Header>
      <Card.Body padding={padding}>{children}</Card.Body>
    </Card>
  );
}
